/* eslint-disable */
// FIXME: enable eslint?
// handles only the myhome-related registration state, all the rest is shared
// with orders.js
import Vue from "vue";
import ModalAlert from "@/components/patterns/ModalAlert"; // eslint-disable-line import/no-extraneous-dependencies
import userLogout from "~/helpers/userLogout"; // eslint-disable-line import/no-extraneous-dependencies
import getPaginationParams from "~/helpers/getPaginationParams"; // eslint-disable-line import/no-extraneous-dependencies
import getUrlSearchParams from "~/helpers/getUrlSearchParams"; // eslint-disable-line import/no-extraneous-dependencies
import Registration from "../../clients/registrations"; // eslint-disable-line import/no-extraneous-dependencies

const state = {
  myHomeRegistrations: {},
  registrationsLoaded: false,
  isRegistrationLoaded: false,
  deeplinkedRegistration: {},
  viewChanged: false,
  searchParams: {
    active: { state: "active" },
    future: { state: ["waiting_list", "pre_registration", "active", "on_hold"] },
    past: { is_event_past: true },
    attended: { is_event_attended: true },
    waitingList: { state: ["waiting_list", "pre_registration"] },
    notAttended: { is_event_unattended: false },
  },
  futureViewFilter: "past",
  dateParams: {
    event__date_range__start: undefined,
    event__date_range__end: undefined,
  },
  limit: 10,
  page: 1,
  myHomePagination: {
    show_first: false,
    show_last: false,
    has_previous: false,
    has_next: false,
    pages: [],
    current: 1,
    last: 1,
  },
};

const getters = {
  filterRegistrations: (moduleState, getters, rootState) => (
    ticketFilter,
    includeBundleChildren,
    deeplinkedRegistration
  ) => {
    let filtered = [];
    for (let item in moduleState.myHomeRegistrations) {
      const registration = moduleState.myHomeRegistrations[item];
      filtered.push(registration);
    }
    return filtered;
  },
  filteredRegistrations: (moduleState, getters, rootState) => includeBundleChildren => {
    return getters.filterRegistrations(
      rootState.myhome.ticketFilter,
      includeBundleChildren,
      moduleState.deeplinkedRegistration
    );
  },
  eventTypes: () => registrations => {
    let types = {};
    for (let registration of registrations) {
      types[registration.linked_event.type] = registration.linked_event.type_label;
    }
    return types;
  },
  myHomeRegistrations: moduleState => moduleState.myHomeRegistrations,
  registrationsLoaded: moduleState => moduleState.registrationsLoaded,
  registrationIsLoaded: moduleState => moduleState.isRegistrationLoaded,
  viewChanged: moduleState => moduleState.viewChanged,
  searchParams: moduleState => moduleState.searchParams,
  dateParams: moduleState => moduleState.dateParams,
  futureViewFilter: moduleState => moduleState.futureViewFilter,
  limit: moduleState => moduleState.limit,
  page: moduleState => moduleState.page,
  myHomePagination: moduleState => moduleState.myHomePagination,
  waitingListRegistrations: (moduleState, getters) => {
    return getters.filteredRegistrations().filter(registration => registration.state === "waiting_list");
  },
};

const actions = {
  async fetchRegistrations({ commit, rootState }, { registrationId = null, params = {} } = {}) {
    window.scrollTo({ top: 0 });
    commit("resetRegistrationsLoaded", false);
    try {
      commit("setDeeplinkedRegistration", registrationId);
      const viewParams =
        (rootState.myhome.ticketFilter !== "past" &&
          rootState.registrations.searchParams[rootState.myhome.ticketFilter]) ||
        {};
      const futureParams =
        (rootState.myhome.ticketFilter === "past" &&
          rootState.registrations.futureViewFilter !== "" &&
          rootState.registrations.searchParams[rootState.registrations.futureViewFilter]) ||
        {};
      let dateParams;
      if (rootState.myhome.ticketFilter === "future") {
        const today = new Date();
        dateParams = {
          event__date_range__start: new Date(today).toISOString(),
        };
        if (rootState.registrations.dateParams.event__date_range__start) {
          dateParams.event__date_range__start = rootState.registrations.dateParams.event__date_range__start.toISOString();
        }
      }
      if (rootState.myhome.ticketFilter === "past") {
        dateParams = {};
        if (rootState.registrations.dateParams.event__date_range__end) {
          dateParams.event__date_range__end = rootState.registrations.dateParams.event__date_range__end.toISOString();
        }
        if (rootState.registrations.dateParams.event__date_range__start) {
          dateParams.event__date_range__start = rootState.registrations.dateParams.event__date_range__start.toISOString();
          if (rootState.registrations.dateParams.event__date_range__end === undefined)
            dateParams.event__date_range__end = new Date(
              new Date(rootState.registrations.dateParams.event__date_range__start).setMonth(
                rootState.registrations.dateParams.event__date_range__start.getMonth() + 6
              )
            ).toISOString();
        }
      }
      const urlParams = getUrlSearchParams({
        ...params,
        page: rootState.registrations.page,
        limit: rootState.registrations.limit,
        ...viewParams,
        ...futureParams,
        ...dateParams,
      });
      const registrations = await Registration.getRegistrations(rootState.config, urlParams);
      commit("setMyHomeRegistrations", registrations.results);
      const pagination = getPaginationParams(registrations, rootState.registrations.limit);
      commit("setMyHomePagination", pagination);
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  async fetchRegistration({ commit, rootState, dispatch }, { registrationId, force }) {
    if (
      rootState.orders.registrations.length !== 1 ||
      rootState.orders.registrations[0].id !== registrationId ||
      force
    ) {
      try {
        const registration = await Registration.getRegistration(rootState.config, registrationId);
        // this is needed to build the same state as during the registration process, without the sliding window
        // behavior
        commit("setRegistrations", [registration]);
        commit("setActiveRegistrationIndex", 0);
        commit("setEmptySessions");
        commit("setMapSelectedLabs");
        commit("updateRegistrationLoading", true);
        dispatch("setSurvey");
      } catch (e) {
        if (e.response && e.response.status === 401) {
          userLogout();
        }
        ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
      }
    }
  },
  async cancelRegistration({ commit, rootState }, registrationId) {
    try {
      const registration = await Registration.cancelRegistration(rootState.config, registrationId);
      commit("replaceMyHomeRegistration", registration);
      return registration;
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
  async fetchBundleData({ commit, rootState }, registrationId) {
    try {
      const bundleData = await Registration.getBundleData(rootState.config, registrationId);
      return bundleData;
    } catch (e) {
      if (e.response && e.response.status === 401) {
        userLogout();
      }
      ModalAlert.methods.handleException(ModalAlert, rootState.config, e);
    }
  },
};

const mutations = {
  setMyHomeRegistrations: (oldState, registrations) => {
    oldState.myHomeRegistrations = {};
    for (let registration of registrations) {
      oldState.myHomeRegistrations[registration.id] = registration;
    }
    oldState.registrationsLoaded = true;
  },
  setFromDateFilter: (oldState, params) => {
    oldState.dateParams.event__date_range__start = params;
  },
  setToDateFilter: (oldState, params) => {
    oldState.dateParams.event__date_range__end = params;
  },
  setFutureViewFilter: (oldState, filter) => {
    oldState.futureViewFilter = filter;
  },
  setMyHomePagination: (oldState, pagination) => {
    oldState.myHomePagination = pagination;
  },
  setDeeplinkedRegistration: (oldState, registration) => {
    oldState.deeplinkedRegistration = registration;
  },
  replaceMyHomeRegistration: (oldState, registration) => {
    Vue.set(oldState.myHomeRegistrations, registration.id, registration);
  },
  updateRegistrationLoading: (oldState, payload) => {
    oldState.isRegistrationLoaded = payload;
  },
  resetRegistrationsLoaded: (oldState, payload) => {
    oldState.registrationsLoaded = payload;
  },
  setViewChanged: (oldState, payload) => {
    oldState.viewChanged = payload;
  },
  setPage: (oldState, payload) => {
    oldState.page = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
